












































import { Component, Vue } from 'vue-property-decorator'
import { State, Action, Getter } from 'vuex-class'

import {
    CurrentStepTitle,
    SFSelect,
    SFRadio,
    SFInput,
    BoxHeading,
    ProgressFooter,
    SFGrid,
    SFLoader
    } from '@/components'

const namespace = 'reports';
const ns_user = {namespace: 'user'}

@Component({
    components: {
        CurrentStepTitle,
        SFSelect,
        SFRadio,
        SFInput,
        BoxHeading,
        ProgressFooter,
        SFGrid,
        SFLoader
    }
})
export default class Authenticate extends Vue {
    @Action('loginRequest', ns_user) loginRequest: any;
    @Action('logout', ns_user) logout: any;
    @Getter('getIsLogged', ns_user) getIsLogged;
    @Getter('getIsLoginError',ns_user) getIsLoginError;

    inProgress: boolean = false;
    login: string = '';
    password: string = '';
    loginError: boolean = false;

    authenticate() {
        const loginDetails = {
            userlogin: this.login,
            password: this.password
        }
        this.inProgress = true;
        this.loginRequest(loginDetails)
        .then((res) => {
            if (this.getIsLogged) {
                this.$router.push('/report/start');
            }
            if (this.getIsLoginError) {
                setTimeout(() => this.logout(), 5000);
                this.inProgress = false;
            }
        });
    }
 };
